import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'htmlSeguro'
})
export class HtmlSeguroPipe implements PipeTransform {

  constructor(private domSanitizer: DomSanitizer) { }

  transform = (value: string, args?: any): SafeHtml =>
    this.domSanitizer.bypassSecurityTrustHtml(value);

}
